// config.santaeulalia.js
  /*
   CICLES (Vicent Garcia i Aina Estrada)

    authCompromis
    authIntranet
    authInternet
    authRecursosDigitals
    authSortides
    authMobils
    authResponsable
    authGDPR
    if( authMedicaCriteria ) d.authMedica = authMedica
    if( authAlternancaCriteria ) d.authAlternanca = authAlternanca

  */

const textInscripcioText = () =>  {

  return (<></>)
  //return (<>CONSULTEU LA <a href="http://www.inssantaeulalia.cat/" target="_blank" rel="noreferrer">PÀGINA WEB DE L'INSTITUT CAVALL BERNAT</a> PER INFORMAR-VOS DEL MATERIAL I ELS LLIBRES QUE NECESSITEU PER INICIAR EL CURS</>)

}

const config =
{
    cid: 'a8043516',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/santaeulalia/)
    autoritzacions: [
        'authAlternanca', 'authCompromis', 'authDretsImatge', 'authGDPR', 'authInternet',
        'authIntranet', 'authMedica', 'authMobils', 'authRecursosDigitals', 'authResponsable',
        'authSortides',
    ],

    phone: "937 314 080",
    email: "secretaria@santaeulalia.cat",

    headerLogo:  'img/logo_bn_santaeulalia.png',
    headerTitle:  'Institut Santa Eulàlia',
    headerURL: 'https://matricula.santaeulalia.cat/',

    //enrollmentPostURL: 'https://matricula.santaeulalia.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.santaeulalia.cat/api/',
    apiURL: '/api/',

    popupInicial: true,

    /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
       curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
       aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: false,

    validaIDdocuments: true,
    tipusDocTSI: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: true,
    validaIAiddocumentFrontFile: false,

    //anysDefecte: 0,
    anysDefecte: 16,

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    autoritzoComunicacioProgenitorsDemanaDades: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: true,
    notesAccesText: "historial d'estudis",

    mostraTorns: true,

    logo: 'img/logo_santaeulalia.jpg',
    titol: 'IES Santa Eulàlia',

    favicon: '/img/favicon-santaeulalia.ico',
    faviconGestio: '/gestio/img/favicon-santaeulalia.ico',

    assignatures: 'assignatures/assignatures.santaeulalia.json',
    //families: 'families/families.santaeulalia.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.santaeulalia.json',
    calculquota: 'quotes.santaeulalia.json',

    /* camps especifics per centre */
    treballantFile: false,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textBotoMatricular: "INSCRIURE",

    proporcionarPreinscripcioNous: true,
    proporcionarTitolPreinscripcioNous: true,

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    urlTPV: "https://matricula.santaeulalia.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    textInscripcioText: null,

    dosTerminisDefault: true, // per defecte el dos terminis està activat
    dosTerminisAmagaBoto: true, // no cal ni mostrar botó

    /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
    dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
    /* si es fals mostrem unes altres condicions de pagament */
    dosTerminisEnabledFalseCondicio: 0,


    sexeNoBinari: false,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;
